module.exports = __webpack_public_path__ + "img/phone.558b5bcd.svg";